import { useRef } from "react";
import { Button } from "./Button.js";
import { Dialog } from "./Dialog.js";

/**
 * D-4 i D-5: potwierdzenie akcji niszczacej. Kazda akcja nieodwracalna przechodzi
 * przez ten komponent - nigdy przez window.confirm (D-1).
 *
 * - tytul jest PYTANIEM z konkretem ("Usunac analize z 4 marca?"), nie "Na pewno?";
 * - przycisk niszczacy nosi KONKRETNY czasownik ("Usun"), nigdy "OK" ani "Tak" (CP-3);
 * - fokus startowy siedzi na "Anuluj" - bezpiecznym domyslnym - i bierze sie z JAWNEGO
 *   refa, nie z kolejnosci elementow w DOM;
 * - klik w tlo TYLKO zamyka, nigdy nie wykonuje akcji;
 * - DG-1: dopiero tutaj wolno uzyc wypelnionej czerwieni (--status-danger-solid).
 *   Wyzwalacz w tresci widoku zostaje soft (wariant "danger").
 * - DG-5: w trakcie usuwania przycisk jest zajety (spinner + blokada 2. klikniecia).
 */
export function ConfirmDialog({
  otwarty,
  tytul,
  tresc = "Tej operacji nie można cofnąć.",
  etykietaPotwierdzenia,
  onPotwierdz,
  onAnuluj,
  zajety = false,
}: {
  otwarty: boolean;
  tytul: string;
  tresc?: string;
  /** CP-3: czasownik skutku, np. "Usun analize". */
  etykietaPotwierdzenia: string;
  onPotwierdz: () => void;
  onAnuluj: () => void;
  zajety?: boolean;
}): React.JSX.Element {
  const anulujRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog
      otwarty={otwarty}
      onZamknij={onAnuluj}
      tytul={tytul}
      poczatkowyFokusRef={anulujRef}
      akcje={
        <>
          <Button ref={anulujRef} wariant="secondary" onClick={onAnuluj}>
            Anuluj
          </Button>
          <Button wariant="danger-solid" zajety={zajety} onClick={onPotwierdz}>
            {etykietaPotwierdzenia}
          </Button>
        </>
      }
    >
      {tresc}
    </Dialog>
  );
}
